import { GetTokenSilentlyOptions } from '@auth0/auth0-react'

type GetAccessTokenSilentlyHandler = (
  options?: GetTokenSilentlyOptions | undefined,
) => Promise<string>

type ReauthHandler = () => void

let getAccessTokenSilentlyHandler: null | GetAccessTokenSilentlyHandler = null
let reauthHandler: null | ReauthHandler = null

// Latches once the first re-auth has been requested. A dead session surfaces from
// both the silent-token path and a backend 401, often on several in-flight queries
// at once; without this guard each one would fire its own redirect. The interactive
// login navigates away and reloads the app, which resets this back to false, so a
// genuinely stale session in a later visit still recovers.
let reauthRequested = false

// Allows RTK Query baseQuery to fetch tokens outside React components.
export const sec = {
  getAccessTokenSilently: (options?: GetTokenSilentlyOptions) =>
    getAccessTokenSilentlyHandler?.(options),

  setAccessTokenSilentlyHandler: (func: GetAccessTokenSilentlyHandler) => {
    getAccessTokenSilentlyHandler = func
  },

  setReauthHandler: (func: ReauthHandler) => {
    reauthHandler = func
  },

  /**
   * Requests interactive re-authentication exactly once per session.
   *
   * Called when the cached Auth0 session can no longer produce a valid token —
   * either the silent token call threw a re-auth-required error or the backend
   * rejected a request with 401. Delegates to the handler the React tree
   * registered (a `loginWithRedirect` wrapper). No-op if no handler is registered
   * yet (e.g. the E2E bypass) or a redirect is already underway.
   */
  requestReauth: () => {
    if (reauthRequested || reauthHandler === null) {
      return
    }
    reauthRequested = true
    reauthHandler()
  },
}
